import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { SimpleStepperComponent } from '../../ui/simple-stepper/simple-stepper.component';
import { UploadCsvFileComponent } from './partials/upload-csv-file/upload-csv-file.component';
import { ListCsvPhoneNumbersComponent } from './partials/list-csv-phone-numbers/list-csv-phone-numbers.component';
import { CsvPhoneNumberReviewComponent } from './partials/csv-phone-number-review/csv-phone-number-review.component';
import { MapCsvColumnsComponent } from './partials/map-csv-columns/map-csv-columns.component';
import { LocalCsvService } from '../../../services/local-csv/local-csv.service';
import { formatCount } from '../../../../utils/sms';

@Component({
  selector: 'app-csv-phone-numbers-upload',
  standalone: true,
  imports: [
    ModalFormContainerComponent,
    SimpleStepperComponent,
    UploadCsvFileComponent,
    ListCsvPhoneNumbersComponent,
    CsvPhoneNumberReviewComponent,
    MapCsvColumnsComponent,
  ],
  templateUrl: './csv-phone-numbers-upload.component.html',
  styleUrl: './csv-phone-numbers-upload.component.css',
})
export class CsvPhoneNumbersUploadComponent {
  constructor() {}

  localCSVService = inject(LocalCsvService);

  @Input() open: boolean = false;
  @Output() close = new EventEmitter();

  steps = [
    { stepName: 'Upload file', stepNumber: 1 },
    { stepName: 'Choose column', stepNumber: 2 },
    { stepName: 'Check numbers', stepNumber: 3 },
    { stepName: 'Review and add', stepNumber: 4 },
  ];

  currentIndex: number = 0;

  goToFileUpload() {
    this.currentIndex = 0;
  }

  goToColumnMapping() {
    this.currentIndex = 1;
  }

  /** Forward from the column step: build the list from the chosen column. */
  goToDataPreview() {
    this.localCSVService.applyMappingAndGenerate();
    this.currentIndex = 2;
  }

  /** Back from the review: only the step changes, so removals and edits stay. */
  backToDataPreview() {
    this.currentIndex = 2;
  }

  goToConfirmUpload() {
    this.currentIndex = 3;
  }

  submitFormattedCSV() {
    this.localCSVService.addCurrentToAllFormatted();
    this.closeModal();
    this.currentIndex = 0;
  }

  get getNextFunction() {
    switch (this.currentIndex) {
      case 1:
        return this.goToDataPreview.bind(this);
      case 2:
        return this.goToConfirmUpload.bind(this);
      case 3:
        return this.submitFormattedCSV.bind(this);
      default:
        return this.goToDataPreview.bind(this);
    }
  }

  get getPreviousFunction() {
    switch (this.currentIndex) {
      case 3:
        return this.backToDataPreview.bind(this);
      case 2:
        return this.goToColumnMapping.bind(this);
      case 1:
        return this.goToFileUpload.bind(this);
      default:
        return undefined;
    }
  }

  get getRightButtonLabel(): string {
    if (this.currentIndex === 3) {
      const count = this.localCSVService.getSubmittableData.length;
      if (!count) return 'No numbers to add';
      return count === 1 ? 'Add 1 number' : `Add ${formatCount(count)} numbers`;
    }
    if (this.currentIndex === 2) return 'Review numbers';
    return 'Continue';
  }

  /** Nothing valid to add: the last step's button stays off. */
  get nextDisabled(): boolean {
    return this.currentIndex === 3 && this.localCSVService.getSubmittableData.length === 0;
  }

  closeModal() {
    this.close.emit();
  }
}
